(function(){
	'use strict';
	angular.module('app.supplyChain')
	.controller('orderPolicies', orderPolicies);
	orderPolicies.$inject = ['$scope', '$state', '$timeout', '$filter', '$location', 'redirectParamsService',
		'leanFilterService', 'tableRenderService', 'tableService', 'integerFormatService', 'storeService'];

	function orderPolicies($scope, $state, $timeout, $filter, $location, redirectParamsService,
			leanFilterService, tableRenderService, tableService, integerFormatService, storeService) {

		var vm = this;
		var unsubscribe;

		var reportSettingsName = 'order-policies';
		// Extra query params to send to backend in data requests
		var extraParams = [{}];
		var rendererParams = {'filterFunction': $filter};
		// Extra drilldown query params to parse
		var extraFilters = [];
		var pinnedColumns = [];


		// Set navigation properties
		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		vm.showExcel = false;

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Order policies';


		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				createSums(response);
				return response;
			});
		}

		function createSums(response){
			var footer = {};
			for (var i = 0; i < columns.length; i++){
				if(columns[i].aggregate == true){
					var sum = 0;
					for(var j = 0; j < response[0].data.length; j++){
						sum += response[0].data[j][columns[i].id];
					}
				}
				else{
					sum = undefined;
				}
				footer[columns[i].id] = sum;
			}
			// Handle days coverage total, has separate logic
			footer['daysCoverage'] = footer['onHandValue'] / footer['avgDailyCost'];

			footer['orderPolicy'] = 'Total';
			response['footer'] = footer;
		}


		init();

		function getOrderInterval(row, col, rowIndx, params) {
			var classString = 'class="cell-div ';
			if (params.lastIndex && rowIndx == params.lastIndex) {
				classString += 'footer ';
			}
			classString += ' " ';
			var orderPolicy = row['orderPolicy'] ? row['orderPolicy'] : '';
			if (row['orderPolicy'] === 'Order Interval') {
				orderPolicy += ' (';
				if (globalConfig.user.authFacts[globalConfig.factory.id].daysDisplayType !== 'Calendar Days') {
					orderPolicy += integerFormatService.getWithParameters(row.orderPolicyValue / 7 * 5, 0) + ' work days)';
				} else {
					orderPolicy += row.orderPolicyValue + ' days)';
				}
			}
			return '<div ' + classString + '>' + orderPolicy + '</div>';
		}

		var columns = [
			{
				'id': 'orderPolicy',
				'display': 'Order Policy',
				'renderer': getOrderInterval,
				'width': 240,
				'show': true,
				'sort': true,
				'position': 0
			},
			{
				'id': 'policy',
				'display': 'ERP Order Policy',
				'renderer': tableRenderService.title,
				'class': 'smallTextCell',
				'width': 240,
				'show': true,
				'title': '',
				'sort': true,
				'position': 1
			},
			{
				'id': 'itemCount',
				'display': 'Number of Items',
				'class': 'numberCell',
				'width': 100,
				'renderer': tableRenderService.integer,
				'show': true,
				'title': '',
				'sort': true,
				'aggregate': true,
				'position': 2
			},
			{
				'id': 'avgDailyCost',
				'display': 'Avg Daily Cost',
				'class': 'buyerCell alignRight',
				'width': 100,
				'renderer': tableRenderService.currency,
				'show': true,
				'sort': true,
				'aggregate': true,
				'position': 3
			},
			{
				'id': 'onHandValue',
				'display': 'On Hand Value',
				'class': 'buyerCell alignRight',
				'width': 100,
				'renderer': tableRenderService.currency,
				'show': true,
				'sort': true,
				'title': '',
				'aggregate': true,
				'position': 4,
				'sortDefaultReverse': true
			},
			{
				'id': 'onOrderValue',
				'display': 'On Order Value',
				'class': 'buyerCell alignRight',
				'width': 100,
				'renderer': tableRenderService.currency,
				'show': true,
				'sort': true,
				'title': '',
				'aggregate': true,
				'position': 5
			},
			{
				'id': 'daysCoverage',
				'display': 'Days Coverage (Work Days)',
				'class': 'buyerCell alignRight',
				'width': 100,
				'renderer': tableRenderService.integer,
				'show': true,
				'sort': true,
				'title': '',
				'aggregate': false,
				'position': 7
			},
			{
				'id': 'percentOfTotalForFactory',
				'display': 'Percent of Total',
				'class': 'buyerCell alignRight',
				'width': 100,
				'renderer': tableRenderService.percent,
				'show': true,
				'sort': true,
				'title': '',
				'position': 8
			}
		];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportSettingsId: reportSettingsId,
			reportName: vm.reportName,
			reportUrl: '{0}/ProcurementPoliciesReport',
			noPaging: true,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultSort: 'onHandValue',
			defaultSortDirection: 'desc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			searchType: 'item',
			hideSearch: true,
			footer:true
		};

		function init() {
			vm.tableName = 'ProcurementPolicies';
			$scope.filterService = leanFilterService;
			$scope.filterService.clearFilters();
			$scope.filterService.useFactoryFilter = true;

			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'singleSelect';
			siteFilter.removable = false;

			$scope.filterService.setMasterFilterList([]);
			$scope.filterService.setMasterSingleSelectFilterList([siteFilter]);
			$scope.filterService.setResetReportSettingsSettings(reportSettingsName);
		}

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}

		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = meta.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
			vm.reportName = meta.reportName;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}

	}

})();
